
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaiairportcarrental() {



    const cardData =
    {
        keyword: ' Mumbai Airport Car Rental',
        heading: 'Skyline Cabs: Mumbai Airport Car Rental',
        headingDescription: 'Skyline Cabs offers reliable and affordable Mumbai Airport Car Rental services for all your travel needs. Whether you are arriving at Terminal 1, 2, or 3, our fleet of clean, well-maintained vehicles—ranging from sedans to SUVs—ensures a smooth and comfortable ride to your destination. With professional chauffeurs, prompt pickups, transparent pricing, and 24/7 customer support, Skyline Cabs is your trusted partner for hassle-free airport transfers. Book your Mumbai Airport car rental today and experience stress-free travel from touchdown to doorstep.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Car Hire Mumbai Airport",
    "description": "Skyline Cabs offers reliable and affordable car hire services at Mumbai Airport. Choose from a wide range of vehicles including sedans, SUVs, and premium cars for a comfortable and hassle-free journey to your destination."
  },
  {
    "name": "Airport Cabs Mumbai",
    "description": "Book airport cabs in Mumbai with Skyline Cabs for a convenient and reliable taxi service. We offer a range of vehicles to suit your needs, ensuring that you travel in comfort and style from Mumbai Airport to any destination."
  },
  {
    "name": "Mumbai Airport Pickup Taxi Service",
    "description": "Skyline Cabs offers an efficient and reliable pickup taxi service from Mumbai Airport. Our professional drivers will greet you at the airport and take you to your destination in comfort, ensuring a smooth and stress-free start to your journey."
  },
  {
    "name": "Mumbai Airport Taxi Fare",
    "description": "Skyline Cabs provides transparent and affordable taxi fares for travel to and from Mumbai Airport. Our pricing is clear, with no hidden charges, and we offer a range of vehicles to meet your budget and comfort needs."
  },
  {
    "name": "Airport Cab Booking Mumbai",
    "description": "Book your airport cab with Skyline Cabs for a reliable and comfortable ride from Mumbai Airport. Whether you're traveling for business or leisure, our booking system is easy to use, and we ensure timely arrivals and departures."
  },
  {
    "name": "Cab Service Mumbai Airport",
    "description": "Skyline Cabs offers dependable cab services at Mumbai Airport, available 24/7. Our fleet of well-maintained vehicles ensures a safe and comfortable ride to your desired location, with experienced drivers offering excellent service."
  },
  {
    "name": "Innova Airport Drop Mumbai",
    "description": "For a premium airport drop experience, choose our Innova Crysta taxi service from Mumbai Airport. Skyline Cabs provides reliable and luxurious airport transfers with spacious vehicles, perfect for families or groups heading to their destinations."
  },
  {
    "name": "Innova Taxi Mumbai Airport",
    "description": "Skyline Cabs offers Innova taxis for your airport transfers in Mumbai. Our well-maintained Innova Crysta vehicles offer comfort and ample space, making them perfect for family trips or group travel to and from Mumbai Airport."
  },
  {
    "name": "Mumbai Airport Terminal 2 to Terminal 1 Taxi Fare",
    "description": "Skyline Cabs provides affordable and convenient taxi services for the transfer between Mumbai Airport's Terminal 2 and Terminal 1. Enjoy a hassle-free ride with transparent pricing and comfortable vehicles."
  },
  {
    "name": "Mumbai International Airport Cab Service",
    "description": "Skyline Cabs offers premium cab services at Mumbai International Airport. Whether you need a transfer to the city or an outstation trip, our fleet of vehicles ensures you travel in comfort with professional drivers for a seamless experience."
  },
  {
    "name": "Chhatrapati Shivaji Maharaj Airport Cabs",
    "description": "Book a cab from Chhatrapati Shivaji Maharaj Airport with Skyline Cabs for a reliable and comfortable ride. We offer a wide range of vehicles, from economy to luxury options, ensuring a smooth journey to your destination."
  },
  {
    "name": "Mumbai Airport to Hadapsar Cab Fare",
    "description": "Skyline Cabs offers affordable taxi services for your trip from Mumbai Airport to Hadapsar. Our pricing is clear and competitive, with comfortable vehicles ensuring a safe and enjoyable journey."
  },
  {
    "name": "Chhatrapati Shivaji Maharaj Terminus to Pune Cab",
    "description": "Skyline Cabs provides convenient and comfortable taxi services from Chhatrapati Shivaji Maharaj Terminus (CST) to Pune. Our experienced drivers and well-maintained vehicles ensure a smooth and safe ride for your outstation trip."
  },
  {
    "name": "Best Mumbai Airport Car Rental Service",
    "description": "Skyline Cabs offers the best car rental services at Mumbai Airport. Choose from a variety of well-maintained vehicles, including luxury cars, SUVs, and economy options, for a comfortable ride to any destination."
  },
  {
    "name": "Best Car Rental in Mumbai",
    "description": "Skyline Cabs provides the best car rental services in Mumbai, offering a wide selection of vehicles for different budgets and travel needs. Whether you need a luxury car, SUV, or sedan, we ensure you travel in comfort and style."
  },
  {
    "name": "Best Car Rental in Mumbai Airport",
    "description": "At Mumbai Airport, Skyline Cabs offers the best car rental options with a fleet of premium and economy vehicles. Our rentals provide comfort, affordability, and convenience, ensuring a pleasant start to your journey."
  },
  {
    "name": "Best Car Rental in Mumbai Airport Innova",
    "description": "Rent an Innova Crysta at Mumbai Airport with Skyline Cabs for a premium travel experience. Our Innova rentals are perfect for families or groups, offering ample space, comfort, and a smooth ride to your destination."
  },
  {
    "name": "7 Seater Innova on Rent in Mumbai",
    "description": "Skyline Cabs offers a 7-seater Innova on rent in Mumbai for group travel or family trips. Our spacious and comfortable vehicles ensure you can travel together in style and comfort, with professional drivers ensuring a smooth ride."
  }
],
"tableData": [
  ["Car Hire Mumbai Airport", "Airport Cabs Mumbai"],
  ["Mumbai Airport Pickup Taxi Service", "Mumbai Airport Taxi Fare"],
  ["Airport Cab Booking Mumbai", "Cab Service Mumbai Airport"],
  ["Innova Airport Drop Mumbai", "Innova Taxi Mumbai Airport"],
  ["Mumbai Airport Terminal 2 to Terminal 1 Taxi Fare", "Mumbai International Airport Cab Service"],
  ["Chhatrapati Shivaji Maharaj Airport Cabs", "Mumbai Airport to Hadapsar Cab Fare"],
  ["Chhatrapati Shivaji Maharaj Terminus to Pune Cab", "Best Mumbai Airport Car Rental Service"],
  ["Best Car Rental in Mumbai", "Best Car Rental in Mumbai Airport"],
  ["Best Car Rental in Mumbai Airport Innova", "7 Seater Innova on Rent in Mumbai"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai Airport Car Rental Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely car rental services from Mumbai Airport. Whether you're arriving for business, leisure, or any other reason, we ensure that your journey starts smoothly and comfortably."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles to Choose From",
        "WhyChoosedescription": "We offer a variety of vehicles for rent, including sedans, SUVs, and luxury cars. Whether you're traveling solo, with family, or in a group, we have the perfect car to meet your needs for a comfortable journey from Mumbai Airport."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced and trained in safe driving practices. They are familiar with the best routes from Mumbai Airport, ensuring that you reach your destination promptly and safely."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers affordable pricing for Mumbai Airport car rentals with no hidden charges. You will know the cost upfront, allowing you to enjoy your ride without any surprises."
    },
    {
        "WhyChooseheading": "24/7 Availability for Convenient Travel",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, ensuring you can book a car rental at any time of the day or night. Whether your flight arrives early in the morning or late at night, we are always ready to serve your travel needs."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
        "WhyChoosedescription": "Booking a car rental is simple and quick with Skyline Cabs. Use our website or mobile app to book your car in just a few clicks, and get instant booking confirmation along with real-time tracking of your ride."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles for Every Trip",
        "WhyChoosedescription": "Your health and safety are our top priority. All of our vehicles are sanitized before each ride, and our drivers follow strict hygiene protocols to ensure a safe and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Comfortable and Smooth Ride",
        "WhyChoosedescription": "Skyline Cabs offers a smooth, comfortable, and efficient car rental experience from Mumbai Airport. Whether it's a short journey or a long ride, we ensure a hassle-free and pleasant travel experience."
    }
]

























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent a car from Mumbai Airport with Skyline Cabs?',
            answer:
                'Renting a car from Mumbai Airport is easy with Skyline Cabs. You can book online through our website, mobile app, or contact our customer support. Just choose your pickup terminal, select a car, and confirm the rental with your travel details.',
        },
        {
            id: 2,
            question: 'What types of cars are available for rental at Mumbai Airport?',
            answer:
                'Skyline Cabs offers a wide range of vehicles at Mumbai Airport, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. You can choose based on your budget, comfort, and group size.',
        },
        {
            id: 3,
            question: 'Is the car rental from Mumbai Airport available 24/7?',
            answer:
                'Yes, Skyline Cabs provides 24/7 car rental services at all Mumbai Airport terminals. No matter what time your flight lands or departs, we’re ready to serve you.',
        },
        {
            id: 4,
            question: 'Are the rental charges from Mumbai Airport fixed?',
            answer:
                'Yes, we offer transparent, fixed pricing with no hidden charges. The rental fare includes driver fees, tolls, and taxes—what you see is what you pay.',
        },
        {
            id: 5,
            question: 'Can I rent a car for a one-way trip from Mumbai Airport?',
            answer:
                'Absolutely. One-way rentals from Mumbai Airport to destinations like Pune, Nashik, or Lonavala are available. Just mention your drop-off location while booking.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my car rental booking from Mumbai Airport?',
            answer:
                'Yes, you can easily modify or cancel your booking via our app, website, or customer support. We offer flexible policies to suit your changing plans.',
        },
        {
            id: 7,
            question: 'Are the rental cars from Mumbai Airport clean and well-maintained?',
            answer:
                'Yes, all our cars are regularly serviced and sanitized. Cleanliness and safety are top priorities to ensure you enjoy a comfortable and worry-free ride.',
        },
        {
            id: 8,
            question: 'What payment options are available for car rentals at Mumbai Airport?',
            answer:
                'We accept secure online payments via credit/debit cards, UPI, and net banking. Cash payment can also be made at the end of the ride.',
        },
        {
            id: 9,
            question: 'Is Mumbai Airport car rental available for corporate travel?',
            answer:
                'Yes, we offer corporate car rental solutions with invoicing and dedicated support. Our cars are ideal for executives, team transfers, and outstation business trips.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for car rentals at Mumbai Airport?',
            answer:
                'Skyline Cabs is known for reliable service, on-time pickups, clean vehicles, and competitive pricing. We provide a seamless rental experience for travelers arriving at or departing from Mumbai Airport.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I rented a car from Mumbai Airport via Skyline Cabs and had a flawless experience. The driver was on time, the car was clean, and the process was smooth from booking to drop-off."
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Skyline Cabs made my car rental from Mumbai Airport easy. Good service, reasonable pricing, and a comfortable ride. Would rent again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport Car Rental",
  "image": "https://skylinecabs.com/assets/images/mumbai-airport-car-rental.jpg",
  "description": "Book Mumbai Airport car rental with Skyline Cabs for seamless pickup from Terminal 1, 2, or 3. Choose from hatchbacks, sedans, SUVs, and premium cars—available 24/7 with professional chauffeurs or self-drive options.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8542"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-airport-car-rental"
  }
};



      
      
      

    return (
        <div>
<Helmet>
  <title>Mumbai Airport Car Rental | Terminal 1, 2, 3 Pickup | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport car rental with Skyline Cabs for seamless pickup from Terminal 1, 2, or 3. Choose from hatchbacks, sedans, SUVs, and premium cars—available 24/7 with professional chauffeurs or self-drive options." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport Car Rental, Car Hire Mumbai Airport, Terminal 1 Car Rental Mumbai, Terminal 2 Cab Booking, Premium Car Rental Mumbai Airport, Sedan SUV Rental Mumbai, 24/7 Car Hire Airport Mumbai, Chauffeur Car Mumbai Airport, Self-Drive Car Mumbai Airport, Skyline Cabs Car Rental" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/56.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairportcarrental;